namespace GeniuzPOS.InitialData {
    export interface PsPanelItemButtonRow {
        Id?: number;
        ItemButtonId?: number;
        ItemButtonLabel?: string;
        TouchPanelType?: string;
        GroupButtonId?: number;
        ItemButtonImage?: string;
        UrlUpload?: string;
        BgColor?: string;
        TxtColor?: string;
        TxtFontSize?: number;
        LinkCode?: string;
        LinkCodeFg?: LinkCodeFg;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PsPanelItemButtonRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ItemButtonLabel';
        export const localTextPrefix = 'InitialData.PsPanelItemButton';
        export const lookupKey = 'InitialData.PsPanelItemButton';

        export function getLookup(): Q.Lookup<PsPanelItemButtonRow> {
            return Q.getLookup<PsPanelItemButtonRow>('InitialData.PsPanelItemButton');
        }
        export const deletePermission = '';
        export const insertPermission = '';
        export const readPermission = '';
        export const updatePermission = '';

        export declare const enum Fields {
            Id = "Id",
            ItemButtonId = "ItemButtonId",
            ItemButtonLabel = "ItemButtonLabel",
            TouchPanelType = "TouchPanelType",
            GroupButtonId = "GroupButtonId",
            ItemButtonImage = "ItemButtonImage",
            UrlUpload = "UrlUpload",
            BgColor = "BgColor",
            TxtColor = "TxtColor",
            TxtFontSize = "TxtFontSize",
            LinkCode = "LinkCode",
            LinkCodeFg = "LinkCodeFg",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
